import styled from 'styled-components';

export default styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-direction: row;
    flex: 1;
    /* @noflip */
    direction: ltr;

    input {
        background: #F5F5F5;
        text-align: center;
        -webkit-appearance: initial;
        font-size: 16px;
        width: 50px;
        height: 50px;
        border: none !important;
        color: #0D2439;
        font-family: Samim;
        border-radius: 5px;
        box-shadow: none !important;
       
        &:hover {
            outline: none;
            border: 1px solid rgb(227, 223, 223) !important;
            border-color: rgb(227, 223, 223) !important;
            ${p => p.completed && `
                outline: none;
                border: 2px solid rgba(41, 188, 171, 1) !important;
                border-color: rgba(41, 188, 171, 1) !important;
            `}
             ${p => p.error && `
                outline: none;
                border: 2px solid red !important;
                border-color: red !important;
            `}
        }
        &:focus {
            outline: none;
            border: 2px solid rgba(41, 188, 171, 1) !important;
            border-color: rgba(41, 188, 171, 1) !important;
            ${p => p.error && `
                outline: none;
                border: 2px solid red !important;
                border-color: red !important;
            `}
        }
        ${p => p.completed && `
            outline: none;
            border: 2px solid rgba(41, 188, 171, 1) !important;
            border-color: rgba(41, 188, 171, 1) !important;
        `}
        ${p => p.error && `
            outline: none;
            border: 2px solid red !important;
            border-color: red !important;
        `}
    }
`;